// 9fbef606107a605d69c0edbcd8029e5d
const TITLES = {
  MOD_TITLE: 'title',
  MOD_SUBTITLE: 'subTitle',
  MOD_PROMO: 'promo',
  MOD_PROMO_SUBTITLE: 'subPromoTitle',
  MOD_PROMO_SUB_HEADER_FS: 'subPromoHeader-fs',
  MOD_PROMO_SUB_HEADER_FW: 'subPromoFW',
  MOD_PROMO_FS: 'offer-fs',
  MOD_HEADER_FS: 'header-fs',
  MOD_BUTTON: 'button',
  MOD_SUB_HEADER_FS: 'subHeader-fs',
};

const COUNTDOWN = {
  MOD_CD_NUM_BACKGROUND: 'cdBgColor',
  MOD_CD_NUM_COLOR: 'cdNumColor',
  MOD_CD_TEXT_COLOR: 'cdTextColor',
  MOD_CD_FONT_SIZE: 'cdFs',
};

const BORDER_RADIUS = {
  MOD_HEADER_TOP: 'header-top',
  MOD_HEADER_BOTTOM: 'header-bottom',

  MOD_MEDIA_TOP: 'media-top',
  MOD_MEDIA_BOTTOM: 'media-bottom',

  MOD_CTA_TOP: 'cta-top',
  MOD_CTA_BOTTOM: 'cta-bottom',

  MOD_IMG_TOP: 'img-top',
  MOD_IMG_BOTTOM: 'img-bottom',

  MOD_SINGLE_CTA_TOP: 'single-cta-group-top',
  MOD_SINGLE_CTA_BOTTOM: 'single-cta-group-bottom',

  MOD_MULTIPLE_CTA_TOP: 'multiple-cta-group-top',
  MOD_MULTIPLE_CTA_BOTTOM: 'multiple-cta-group-bottom',
};

const BORDER_RADIUS_BIRTHDAY_MODULE = {
  MOD_BDAY_M1_ALIGN: 'bday-m1-align',
  MOD_BDAY_M2_ALIGN: 'bday-m2-align',
};

const BACKGROUND_COLOR = {
  MOD_BGCOLOR_COLORCODE: 'bgColor-colorCode',
};

const CTA_PADDING = {
  MOD_CTA_PADDING_TOP: 'cta-padding-top',
  MOD_CTA_PADDING_BOTTOM: 'cta-padding-bottom',
};

const BORDER_RADIUS_MODULE_CONTAINER = {
  MOD_HEADER1_COL1_TOP: 'col1-header1-top',
  MOD_HEADER1_COL1_TOP_LEFT: 'col1-header1-top-left',
  MOD_HEADER1_COL1_TOP_RIGHT: 'col1-header1-top-right',
  MOD_HEADER1_COL2_TOP: 'col2-header1-top',
  MOD_HEADER1_COL2_TOP_LEFT: 'col2-header1-top-left',
  MOD_HEADER1_COL2_TOP_RIGHT: 'col2-header1-top-right',
  MOD_HEADER1_COL3_TOP: 'col3-header1-top',
  MOD_HEADER1_COL3_TOP_LEFT: 'col3-header1-top-left',
  MOD_HEADER1_COL3_TOP_RIGHT: 'col3-header1-top-right',
  MOD_HEADER1_COL4_TOP: 'col4-header1-top',
  MOD_HEADER1_COL4_TOP_LEFT: 'col4-header1-top-left',
  MOD_HEADER1_COL4_TOP_RIGHT: 'col4-header1-top-right',
  MOD_HEADER1_COL1_BOTTOM: 'col1-header1-bottom',
  MOD_HEADER1_COL1_BOTTOM_LEFT: 'col1-header1-bottom-left',
  MOD_HEADER1_COL1_BOTTOM_RIGHT: 'col1-header1-bottom-right',
  MOD_HEADER1_COL2_BOTTOM: 'col2-header1-bottom',
  MOD_HEADER1_COL2_BOTTOM_LEFT: 'col2-header1-bottom-left',
  MOD_HEADER1_COL2_BOTTOM_RIGHT: 'col2-header1-bottom-right',
  MOD_HEADER1_COL3_BOTTOM: 'col3-header1-bottom',
  MOD_HEADER1_COL3_BOTTOM_LEFT: 'col3-header1-bottom-left',
  MOD_HEADER1_COL3_BOTTOM_RIGHT: 'col3-header1-bottom-right',
  MOD_HEADER1_COL4_BOTTOM: 'col4-header1-bottom',
  MOD_HEADER1_COL4_BOTTOM_LEFT: 'col4-header1-bottom-left',
  MOD_HEADER1_COL4_BOTTOM_RIGHT: 'col4-header1-bottom-right',

  MOD_HEADER2_COL1_TOP: 'col1-header2-top',
  MOD_HEADER2_COL1_TOP_LEFT: 'col1-header2-top-left',
  MOD_HEADER2_COL1_TOP_RIGHT: 'col1-header2-top-right',
  MOD_HEADER2_COL2_TOP: 'col2-header2-top',
  MOD_HEADER2_COL2_TOP_LEFT: 'col2-header2-top-left',
  MOD_HEADER2_COL2_TOP_RIGHT: 'col2-header2-top-right',
  MOD_HEADER2_COL3_TOP: 'col3-header2-top',
  MOD_HEADER2_COL3_TOP_LEFT: 'col3-header2-top-left',
  MOD_HEADER2_COL3_TOP_RIGHT: 'col3-header2-top-right',
  MOD_HEADER2_COL4_TOP: 'col4-header2-top',
  MOD_HEADER2_COL4_TOP_LEFT: 'col4-header2-top-left',
  MOD_HEADER2_COL4_TOP_RIGHT: 'col4-header2-top-right',
  MOD_HEADER2_COL1_BOTTOM: 'col1-header2-bottom',
  MOD_HEADER2_COL1_BOTTOM_LEFT: 'col1-header2-bottom-left',
  MOD_HEADER2_COL1_BOTTOM_RIGHT: 'col1-header2-bottom-right',
  MOD_HEADER2_COL2_BOTTOM: 'col2-header2-bottom',
  MOD_HEADER2_COL2_BOTTOM_LEFT: 'col2-header2-bottom-left',
  MOD_HEADER2_COL2_BOTTOM_RIGHT: 'col2-header2-bottom-right',
  MOD_HEADER2_COL3_BOTTOM: 'col3-header2-bottom',
  MOD_HEADER2_COL3_BOTTOM_LEFT: 'col3-header2-bottom-left',
  MOD_HEADER2_COL3_BOTTOM_RIGHT: 'col3-header2-bottom-right',
  MOD_HEADER2_COL4_BOTTOM: 'col4-header2-bottom',
  MOD_HEADER2_COL4_BOTTOM_LEFT: 'col4-header2-bottom-left',
  MOD_HEADER2_COL4_BOTTOM_RIGHT: 'col4-header2-bottom-right',

  MOD_MEDIA_COL1_TOP: 'col1-media-top',
  MOD_MEDIA_COL1_TOP_LEFT: 'col1-media-top-left',
  MOD_MEDIA_COL1_TOP_RIGHT: 'col1-media-top-right',
  MOD_MEDIA_COL2_TOP: 'col2-media-top',
  MOD_MEDIA_COL2_TOP_LEFT: 'col2-media-top-left',
  MOD_MEDIA_COL2_TOP_RIGHT: 'col2-media-top-right',
  MOD_MEDIA_COL3_TOP: 'col3-media-top',
  MOD_MEDIA_COL3_TOP_LEFT: 'col3-media-top-left',
  MOD_MEDIA_COL3_TOP_RIGHT: 'col3-media-top-right',
  MOD_MEDIA_COL4_TOP: 'col4-media-top',
  MOD_MEDIA_COL4_TOP_LEFT: 'col4-media-top-left',
  MOD_MEDIA_COL4_TOP_RIGHT: 'col4-media-top-right',
  MOD_MEDIA_COL1_BOTTOM: 'col1-media-bottom',
  MOD_MEDIA_COL1_BOTTOM_LEFT: 'col1-media-bottom-left',
  MOD_MEDIA_COL1_BOTTOM_RIGHT: 'col1-media-bottom-right',
  MOD_MEDIA_COL2_BOTTOM: 'col2-media-bottom',
  MOD_MEDIA_COL2_BOTTOM_LEFT: 'col2-media-bottom-left',
  MOD_MEDIA_COL2_BOTTOM_RIGHT: 'col2-media-bottom-right',
  MOD_MEDIA_COL3_BOTTOM: 'col3-media-bottom',
  MOD_MEDIA_COL3_BOTTOM_LEFT: 'col3-media-bottom-left',
  MOD_MEDIA_COL3_BOTTOM_RIGHT: 'col3-media-bottom-right',
  MOD_MEDIA_COL4_BOTTOM: 'col4-media-bottom',
  MOD_MEDIA_COL4_BOTTOM_LEFT: 'col4-media-bottom-left',
  MOD_MEDIA_COL4_BOTTOM_RIGHT: 'col4-media-bottom-right',

  MOD_CTA_COL1_TOP: 'col1-cta-top',
  MOD_CTA_COL2_TOP: 'col2-cta-top',
  MOD_CTA_COL3_TOP: 'col3-cta-top',
  MOD_CTA_COL4_TOP: 'col4-cta-top',
  MOD_CTA_COL5_TOP: 'col5-cta-top',
  MOD_CTA_COL1_BOTTOM: 'col1-cta-bottom',
  MOD_CTA_COL2_BOTTOM: 'col2-cta-bottom',
  MOD_CTA_COL3_BOTTOM: 'col3-cta-bottom',
  MOD_CTA_COL4_BOTTOM: 'col4-cta-bottom',
  MOD_CTA_COL5_BOTTOM: 'col5-cta-bottom',

  MOD_SINGLE_CTA_COL1_TOP: 'col1-single-cta-group-top',
  MOD_SINGLE_CTA_COL2_TOP: 'col2-single-cta-group-top',
  MOD_SINGLE_CTA_COL3_TOP: 'col3-single-cta-group-top',
  MOD_SINGLE_CTA_COL4_TOP: 'col4-single-cta-group-top',
  MOD_SINGLE_CTA_COL5_TOP: 'col5-single-cta-group-top',
  MOD_SINGLE_CTA_COL1_BOTTOM: 'col1-single-cta-group-bottom',
  MOD_SINGLE_CTA_COL2_BOTTOM: 'col2-single-cta-group-bottom',
  MOD_SINGLE_CTA_COL3_BOTTOM: 'col3-single-cta-group-bottom',
  MOD_SINGLE_CTA_COL4_BOTTOM: 'col4-single-cta-group-bottom',
  MOD_SINGLE_CTA_COL5_BOTTOM: 'col5-single-cta-group-bottom',

  MOD_MULTIPLE_CTA_COL1_TOP: 'col1-multiple-cta-group-top',
  MOD_MULTIPLE_CTA_COL2_TOP: 'col2-multiple-cta-group-top',
  MOD_MULTIPLE_CTA_COL3_TOP: 'col3-multiple-cta-group-top',
  MOD_MULTIPLE_CTA_COL4_TOP: 'col4-multiple-cta-group-top',
  MOD_MULTIPLE_CTA_COL5_TOP: 'col5-multiple-cta-group-top',
  MOD_MULTIPLE_CTA_COL1_BOTTOM: 'col1-multiple-cta-group-bottom',
  MOD_MULTIPLE_CTA_COL2_BOTTOM: 'col2-multiple-cta-group-bottom',
  MOD_MULTIPLE_CTA_COL3_BOTTOM: 'col3-multiple-cta-group-bottom',
  MOD_MULTIPLE_CTA_COL4_BOTTOM: 'col4-multiple-cta-group-bottom',
  MOD_MULTIPLE_CTA_COL5_BOTTOM: 'col5-multiple-cta-group-bottom',
};

const CONTAINER_MODULE_SPACING = {
  MOD_MARGIN_BOTTOM: 'marginBottom',
  MOD_MARGIN_TOP: 'marginTop',
  MOD_SPACING_COL1_MARGIN_TOP: 'col1-spacing-margin-top',
  MOD_SPACING_COL2_MARGIN_TOP: 'col2-spacing-margin-top',
  MOD_SPACING_COL3_MARGIN_TOP: 'col3-spacing-margin-top',
  MOD_SPACING_COL4_MARGIN_TOP: 'col4-spacing-margin-top',
  MOD_SPACING_COL5_MARGIN_TOP: 'col5-spacing-margin-top',
  MOD_SPACING_COL1_MARGIN_BOTTOM: 'col1-spacing-margin-bottom',
  MOD_SPACING_COL2_MARGIN_BOTTOM: 'col2-spacing-margin-bottom',
  MOD_SPACING_COL3_MARGIN_BOTTOM: 'col3-spacing-margin-bottom',
  MOD_SPACING_COL4_MARGIN_BOTTOM: 'col4-spacing-margin-bottom',
  MOD_SPACING_COL5_MARGIN_BOTTOM: 'col5-spacing-margin-bottom',
};

const BUNDLE_VARIATION_PROMO = {
  MOD_TAB1_BUNDLE_PROMO: 'tab1-bundle-promo',
  MOD_TAB1_OPTIONAL_PROMO: 'tab1-optional-promo',
  MOD_TAB2_BUNDLE_PROMO: 'tab2-bundle-promo',
  MOD_TAB2_OPTIONAL_PROMO: 'tab2-optional-promo',
  MOD_TAB3_BUNDLE_PROMO: 'tab3-bundle-promo',
  MOD_TAB3_OPTIONAL_PROMO: 'tab3-optional-promo',
  MOD_TAB4_BUNDLE_PROMO: 'tab4-bundle-promo',
  MOD_TAB4_OPTIONAL_PROMO: 'tab4-optional-promo',
  MOD_TAB5_BUNDLE_PROMO: 'tab5-bundle-promo',
  MOD_TAB5_OPTIONAL_PROMO: 'tab5-optional-promo',
};

const BOX_SHADOW = {
  MOD_REMOVE_TOP_SHADOW: 'removeShadow',
};

const CARD_SLIDER = {
  MOD_CARD_SLIDER: 'cardSlider',
};

const HIDE_IN_BETWEEN_LINE = {
  MOD_HIDE_IN_BETWEEN_LINE: 'hideInBetweenLine',
};

const SLIDER_FADE = 'slider-fade';

const SLIDER_SPEED = 'slider-speed';

const ANIMATION_SPEED = 'animation-speed';

const ZOOM_HOVER = 'zoomHover';

const LIVE_HEADER_TEXT_BOTTOM = 'liveTextHeaderBottom';

const SUB_CATEGORY_PROMO_FILTER = {
  MOD_CARD_ANIMATION: 'cardAnimation',
  MOD_IMAGE_PLACEMENT: 'imagePlacement',
  MOD_HERO_IMAGE_WIDTH: 'heroImageWidth',
  MOD_HERO_IMAGE_BANNER: 'heroImageBanner',
  MOD_SUB_CATEGORY_FILTER: 'subCategoryFilter',
};

const JEAN_V2_DESIGN = {
  MOD_JEAN_V2_DESIGN: 'v2-design',
};

export const MODULES = {
  Default: {
    ...TITLES,
    ...BORDER_RADIUS,
  },
  ModuleA: {
    MOD_RIBBON: 'ribbon',
    MOD_NAV_BACKGROUND: 'nav-bg',
    MOD_TEXT_WIDTH: 'textWidth',
    MOD_IMAGE_HEIGHT: 'imgHeight',
    MOD_POSTER_HEIGHT: 'posterHeight',
    MOD_SLIDER_FADE: SLIDER_FADE,
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    MOD_PLP_POP_UP_MEDIA: 'plpPopUpMedia',
    MOD_POP_UP_POSTER_ASPECT_RATIO_D: 'popUpPosterAspectRatioD',
    MOD_POP_UP_POSTER_ASPECT_RATIO_M: 'popUpPosterAspectRatioM',
    MOD_ENABLE_MUTE: 'enableMute',
    MOD_MARGIN_BOTTOM: 'marginBottom',
    MOD_MARGIN_TOP: 'marginTop',
    ...TITLES,
    ...BORDER_RADIUS,
    ...BOX_SHADOW,
    ...CARD_SLIDER,
  },
  ModuleB: {
    MOD_BORDER: 'border',
    MOD_OVERLAY_BACKGROUND_COLOR: 'overlayBgColor',
    MOD_OVERLAY_RULER_COLOR: 'overlayRulerColor',
    MOD_IMAGE_HEIGHT: 'imgHeight',
    MOD_SLIDER_FADE: SLIDER_FADE,
    MOD_NAV_BACKGROUND: 'nav-bg',
    MOD_LIVE_TEXT: LIVE_HEADER_TEXT_BOTTOM,
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    MOD_ANIMATION_SPEED: ANIMATION_SPEED,
    MOD_ENABLE_MUTE: 'enableMute',
    ...TITLES,
    ...BORDER_RADIUS,
    ...BOX_SHADOW,
    ...CARD_SLIDER,
  },
  ModuleE: {
    MOD_TOP_DIVIDER: 'top-div',
    MOD_BOTTOM_DIVIDER: 'bottom-div',
    MOD_EYE_BROW: 'eyeBrow',
    MOD_SLIDER_FADE: SLIDER_FADE,
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    ...TITLES,
    ...BORDER_RADIUS,
    ...BOX_SHADOW,
  },
  ModuleJ: {
    MOD_BORDER: 'border',
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    MOD_MARGIN_BOTTOM: 'marginBottom',
    MOD_MARGIN_TOP: 'marginTop',
    ...TITLES,
    ...BORDER_RADIUS,
    ...BOX_SHADOW,
  },
  ModuleM: {
    MOD_BACKGROUND: 'bground',
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    ...TITLES,
    ...BORDER_RADIUS,
    ...BOX_SHADOW,
  },
  ModuleN: {
    MOD_BACKGROUND: 'bground',
    MOD_MARGIN_BOTTOM: 'marginBottom',
    MOD_MARGIN_TOP: 'marginTop',
    MOD_IMAGE_HEIGHT: 'imgHeight',
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    ...TITLES,
    ...BORDER_RADIUS,
    ...BOX_SHADOW,
  },
  ModuleQ: {
    MOD_BACKGROUND: 'bground',
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    ...BORDER_RADIUS,
    ...TITLES,
    ...BOX_SHADOW,
  },
  ModuleS: {
    MOD_RIBBON: 'ribbon',
    MOD_TEXT_RIBBON_COLOR: 'ribnText-color',
    MOD_MARGIN_BOTTOM: 'marginBottom',
    MOD_HEADER_TEXT_BACKGROUND: 'header-bg',
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    ...BORDER_RADIUS,
    ...TITLES,
    ...BOX_SHADOW,
  },
  ModuleT: {
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    ...TITLES,
    ...BORDER_RADIUS,
    ...BOX_SHADOW,
  },
  ModuleX: {
    MOD_MARGIN_BOTTOM: 'marginBottom',
    MOD_MARGIN_TOP: 'marginTop',
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    ...TITLES,
  },
  ModuleD: {
    MOD_HEADER_TEXT_1: 'headerText1',
    MOD_HEADER_TEXT_2: 'headerText2',
    MOD_HEADER_TEXT_3: 'headerText3',
    MOD_HEADER_BOTTOM_SPACING: 'header-bottom-spacing',
    MOD_TILE_IN_BETWEEN_SPACING: 'tile-inBetween-space',
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    MOD_MARGIN_BOTTOM: 'marginBottom',
    MOD_MARGIN_TOP: 'marginTop',
    ...TITLES,
    ...BORDER_RADIUS,
    ...BOX_SHADOW,
    ...BACKGROUND_COLOR,
    ...CTA_PADDING,
  },
  ModuleContainer: {
    MOD_NAV_BACKGROUND: 'nav-bg',
    MOD_IMG_CMP_HEIGHT: 'imgCmpHeight',
    MOD_IMG_COL1_HEIGHT: 'col1-imgHeight',
    MOD_IMG_COL2_HEIGHT: 'col2-imgHeight',
    MOD_IMG_COL3_HEIGHT: 'col3-imgHeight',
    MOD_IMG_COL4_HEIGHT: 'col4-imgHeight',
    MOD_TEXT_WIDTH: 'textWidth',
    MOD_SLIDER_FADE: SLIDER_FADE,
    MOD_SLIDER_SPEED: SLIDER_SPEED,
    MOD_ANIMATION_SPEED: ANIMATION_SPEED,
    MOD_CAROUSEL_PADDING: 'carousel-padding',
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    MOD_ENABLE_MUTE: 'enableMute',
    MOD_LIVE_TEXT: LIVE_HEADER_TEXT_BOTTOM,
    MOD_ENABLE_PARTNER_IMAGE_SCROLL: 'partner-image-scroll',
    MOD_HIDE_IMAGE_CARD_DESIGN: 'hide-image-card-design',
    MOD_TILE_IN_BETWEEN_SPACING: 'tile-inBetween-space',
    MOD_IMAGE_SCROLL_DIRECTION: 'image-scroll-direction',
    MOD_MEDIA_WIDTH: 'media-width',
    MOD_SLIDER_AUTOPLAY_DISABLED: 'autoplayDisabled',
    ...TITLES,
    ...BORDER_RADIUS_MODULE_CONTAINER,
    ...COUNTDOWN,
    ...BOX_SHADOW,
    ...HIDE_IN_BETWEEN_LINE,
    ...CARD_SLIDER,
    ...CONTAINER_MODULE_SPACING,
    ...SUB_CATEGORY_PROMO_FILTER,
  },
  ModuleDynamic: {
    MOD_BIA_BACKGROUND: 'bia-bgColor',
    MOD_RNR_BACKGROUND: 'rnr-bgColor',
    MOD_TEXT_COLOR: 'text-color',
    MOD_IMAGE_FIT_TYPE: 'imageFitType',
    MOD_HIDE_DISCLAIMER: 'hideDisclaimer',
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    ...BORDER_RADIUS,
    ...BORDER_RADIUS_BIRTHDAY_MODULE,
  },
  OutfitCarousel: {
    ...TITLES,
    ...BORDER_RADIUS,
    ...BOX_SHADOW,
    MOD_ZOOM_HOVER: ZOOM_HOVER,
    MOD_CAROUSEL_SLIDES: 'carousel-slides',
    MOD_NEW_VARIATION: 'variation2',
    MOD_NEW_VARIATION_V3: 'variation3',
    MOD_OUTFIT_PILL_WIDTH: 'pillWidth',
    MOD_OUTFIT_PILL_HEIGHT: 'pillHeight',
    MOD_OUTFIT_PILL_COLOR: 'pillColor',
    MOD_OUTFIT_PILL_FONT_SIZE: 'pillFontSize',
    MOD_OUTFIT_SHOW_ARROW_BEYOND: 'showArrowBeyond',
    MOD_OUTFIT_HIDE_HEADER_SECTION: 'hideHeaderTitle',
    MOD_OUTFIT_PILL_BG_COLOR: 'pillBGColor',
    MOD_MARGIN_BOTTOM: 'marginBottom',
    MOD_MARGIN_TOP: 'marginTop',
  },
  ModuleTabbedCarousel: {
    ...BORDER_RADIUS,
    ...BOX_SHADOW,
    MOD_MARGIN_BOTTOM: 'marginBottom',
    MOD_MARGIN_TOP: 'marginTop',
  },
  JeansModule: {
    ...JEAN_V2_DESIGN,
  },
  ModuleG: {
    ...TITLES,
    ...BORDER_RADIUS,
    ...BUNDLE_VARIATION_PROMO,
    MOD_BUNDLE_VARIATION: 'bundleVariation',
    MOD_PRICE_TEXT_COLOR: 'priceTextColor',
    MOD_LIST_PRICE_COLOR: 'listPriceColor',
    MOD_MERCHANT_TAG_COLOR: 'merchantTagColor',
  },
};

export const DEVICE_TYPE = {
  WEB: 'web',
  MOBILE: 'app',
  MOBILE_WEB: 'mobile',
  GENERIC: 'generic',
};
